export default defineI18nLocale(async (locale) => {

    const config = useRuntimeConfig();

    if(!config.public.appEnvironment.includes('prod')){
        return $fetch(`/api/translation-strings/${locale}.json`);
    }

    const response = await $fetch(`${config.public.translationCdnUrl}/${locale}.json`,{
        retry: 0
    });

    if(response.length === 0 || Object.keys(response).length === 0){
        return null;
    }

    return response;
});


